import { render } from "./PersoneInCaption.vue?vue&type=template&id=08b9607f&scoped=true"
import script from "./PersoneInCaption.vue?vue&type=script&lang=js"
export * from "./PersoneInCaption.vue?vue&type=script&lang=js"

import "./PersoneInCaption.vue?vue&type=style&index=0&id=08b9607f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b9607f"]])

export default __exports__